<template>
  <div>
    <q-dialog v-model="show" :maximized="maximized" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ label }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container style="max-height: 85vh;" class="scroll">
          <crud-layout-page
            v-if="!detail"
            ref="page"
            :params="params"
            :forms="forms"
            @action-button="actionButton"
            @show-message="showMessage"
            @composition-button-click="(butt) => $emit('composition-button-click', butt)"
            @on-select-change="(data) => $emit('on-select-change', data)"
            @search-found="(d) => { $emit('search-found', d) }"
            @on-select-ajax="(d) => { $emit('on-select-ajax', d) }"
            @form-reset="(d) => { $emit('form-reset', d) }" >
            <slot
              name="form"
              slot="form"
              :form="forms[0]"
              :actionButton="actionButton"
              form-class="form dynamic"
            >
            </slot>
          </crud-layout-page>

          <page-detail style="margin-bottom: 10px; margin-top: 30px;"
            v-if="detail"
            :params="params"
            :forms="forms"
            @action-button="actionButton"
            @show-message="showMessage"
          />
        </q-page-container>
      </q-layout>

    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { modal } = JtCrud
import { QDialog, Dialog } from 'quasar'
import PageDetail from './PageDetail.vue'
@Component({
  mixins: [modal],
  name: 'FixedOrderPageDetail',
  components: {
    QDialog,
    Dialog,
    PageDetail
  },
  props: {
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    itemsLateGroup: {
      type: Array,
      default: []
    }
  }
})
class IndustrialMovimantationDetail extends Vue {

}
export default IndustrialMovimantationDetail
</script>
<style lang="stylus">
.q-page-container {
  padding-top: 60px !important;
}
</style>
